<template>
    <div class="installments-mono-phone">
        <p class="installments-mono-phone__text">{{ messages.monoPhone }}</p>
<!--        @input="handlerInput"-->
        <DefPhone
            :label="messages.phone"
            :required="true"
            :value="inputPhone"
            :showError="!!errorMessage"
            :invalidText="errorMessage"
            @input="handlerInput"
            @blur="checkInputPhone"
        />
        <p class="installments-mono-phone__small">{{ messages.monoAfterPay }}</p>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import DefPhone from "../../def/DefPhone/DefPhone";

const { state, dispatch, commit } = useStore();


const checkout = state.checkout?.data;
const messages = computed(() => checkout.vue?.messages);

const phoneData = computed(() => checkout.ORDER_PROP?.properties?.find(el => el.CODE === 'MONO_BANK_PHONE'));

const inputPhone = ref('');
const errorMessage = ref('');

const handlerInput = ({ target: { value } }) => {
    inputPhone.value = value.replace(/ /g, '');
    // commit('checkout/setRequestData', { name: phoneData.inputName, value });
}

const setPhoneToRequestData = (value) => {
    try {
        const inputName = phoneData?.value?.inputName;
        if (inputName) {
            commit('checkout/setRequestData', { name: inputName, value });
        } else {
            throw 'something went wrong';
        }
    } catch (err) {
        console.error(err);
    }

}

const checkPhoneInMonobank = async (phoneNumber) => {
    try {
        const phone = phoneNumber?.replace(/ /g, '') || state?.personal?.data?.authInfo?.user_phone_number;
        // const phone = "+380631455232";
        const { path, ['params-example-data'] : { action } } = state?.checkout?.data?.vue?.routes?.validateMonoBankPhone;
        const params = {
            path,
            action,
            phone
        }

        const { data, status } = await axios.post(path, params);

        if (status !== 200) {
            throw `something went wrong`;
        }

        if (data.status === true) {
            inputPhone.value = phone;
            setPhoneToRequestData(phone);
        } else {
            setPhoneToRequestData();
            inputPhone.value = '';
        }

        return data;
    } catch (err) {
        console.error(err);
    }
}

const checkInputPhone = async ({ target }) => {
    // console.dir(target);
    if (target.validity.valid) {
        commit('global/loaderStart');
        const data = await checkPhoneInMonobank(target.value);
        if (data.error) {
            errorMessage.value = data.error;
        } else {
            errorMessage.value = '';
        }
        commit('global/loaderStop');
    }

}

onMounted(() => {
    checkPhoneInMonobank();
});

</script>

<script>
export default {
    name: 'InstallmentsMonoPhone',
}
</script>

<style lang="scss" scoped>
.installments-mono-phone{
    &__text{
        margin: 24px 0 16px;
        font-weight: 500;
        font-size: rem(16);
        line-height: 125%;
    }
    &__small{
        font-weight: 500;
        font-size: rem(14);
        line-height: 125%;
        color: var(--color-dark-grey);
    }
}
</style>